import React from 'react';
import './AboutSection.css';

function AboutSection() {
    window.scrollTo(0,0);
    return (
        <div className='cuntainer'>
            <p className='para-text'>
            Frazier Sheet Metal Inc. is a family owned and operated sheet metal company that fabricates and installs commercial HVAC ductwork and equipment. In business since 1990, Frazier has grown from a one man operation founded by Stephen B. 
            Frazier with the support of his wife Jean, to a company of 20-50 employees all the while keeping the family values and traditions through Safety culture, loyal, hardworking, tenured employees. Our employees are trained through Local 17 Sheet Metal Workers and are all OSHA trained and certified. 
            Our shop features include coil line, plasma table, full weld shop, CAD department and much more. We specialize in Galvanized Duct, Stainless Steel, Aluminum and Black Iron. FSM is proud to be a member of SMACNA and the Sheet Metal Workers International Association (SMART). 
            </p>
        </div>
    )
}

export default AboutSection
